module.exports = __webpack_public_path__ + "img/1.cb74174c.jpg";